import { t, locale } from '../i18n';
import { appStoreUrl, detectOS } from '../lib/os';

/**
 * Post-arrival store CTA. The hero already says "{name} arrived safely",
 * so the card is just the action — no heading, no blurb. A single button,
 * pointed at whichever store matches the watcher's device (iOS → App Store,
 * Android → Play Store, desktop/other → App Store landing).
 */
export function DownloadAppCard() {
  const os = detectOS();
  const url = appStoreUrl(os, locale.value);
  const label =
    os === 'ios' ? t('download.iosCta')
    : os === 'android' ? t('download.androidCta')
    : t('download.otherCta');

  return (
    <section class="mt-4">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        class="block rounded-lg bg-primary px-3 py-2 text-center text-sm font-semibold text-white hover:bg-primary-light transition-colors"
      >
        {label}
      </a>
    </section>
  );
}
